import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconRowHeightLarge = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.25 9C4.25 8.58579 4.58579 8.25 5 8.25H19C19.4142 8.25 19.75 8.58579 19.75 9C19.75 9.41421 19.4142 9.75 19 9.75H5C4.58579 9.75 4.25 9.41421 4.25 9Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.25 15C4.25 14.5858 4.58579 14.25 5 14.25H19C19.4142 14.25 19.75 14.5858 19.75 15C19.75 15.4142 19.4142 15.75 19 15.75H5C4.58579 15.75 4.25 15.4142 4.25 15Z",
		fill: "currentColor"
	})]
});
export { SvgIconRowHeightLarge as ReactComponent };
